import { VERSION } from '@/app/core/env'
import * as Sentry from '@sentry/vue'
import { Vue } from '@sentry/vue/types/types'

export function configureSentry(app: Vue, router: any) {
  console.log('configureSentry ::::', location.hostname)
  if (location.hostname === 'next.nominasaps.com') {
    Sentry.init({
      release: 'aps@' + VERSION(),
      app,
      dsn: 'https://3a7da6b0363e7bd1fc0cf9d31326d0d6@o4505837159251968.ingest.us.sentry.io/4507098297466880',
      integrations: [
        Sentry.browserTracingIntegration({
          router,
          tracingOrigins: ['https://next.nominasaps.com']
        }),
        Sentry.replayIntegration({
          networkDetailAllowUrls: [
            'https://api-next.nominasaps.com',
            'api-next.nominasaps.com'
          ],
          networkCaptureBodies: true,
          networkRequestHeaders: [
            'Authorization',
            'x-country-id',
            'x-country-code',
            'x-company-id',
            'x-payroll-id',
            'x-channel',
            'user-timezone'
          ],
          maskAllInputs: false,
          maskAllText: false
        })
      ],
      // Performance Monitoring
      tracesSampleRate: 0, // deshabilita spans
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['https://api-next.nominasaps.com'],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
  }
}
